<template>
  <div class="m-head">
    <div class="line flex-between">
      <!-- <img :src="logo" class="logo" /> -->
      <div></div>
      <Nav></Nav>
    </div>
    <div :class="{ bg: route.path == '/home' }">
      <p v-show="route.path == '/home'">{{ name }}浏览器</p>
      <Search></Search>
    </div>
  </div>
</template>

<script setup>
import Nav from "@/components/mobile/Nav";
import Search from "@/components/common/Search";
import { useRoute } from "vue-router";

const logo = require(`../../assets/img/common/${process.env.VUE_APP_LOGO_NOTHOME}`);
const name = process.env.VUE_APP_PROJECT_TITLE;
const route = useRoute();
</script>

<style lang="scss" scoped>
.m-head {
  min-height: 103px;
  background: $white;

  .line {
    height: 45px;
    width: 342px;
    margin: 0 auto;

    .logo {
      height: 100%;
      max-height: 40px;
    }
  }

  .bg {
    height: 260px;
    padding-top: 78px;
    background: url("../../assets/img/mobile/banner.png");

    p {
      margin-bottom: 39px;
      text-align: center;
      font-size: 29px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
  }
}
</style>
